import { api } from './auth.service';

const empresaService = {

  listar: async () => {
    const res = await api.get('/empresas');
    return res.data;
  },

  buscarPorId: async (id) => {
    const res = await api.get(`/empresas/${id}`);
    return res.data;
  },

  incluir: async (dados) => {
    const res = await api.post('/empresas', dados);
    return res.data;
  },

  alterar: async (id, dados) => {
    const res = await api.put(`/empresas/${id}`, dados);
    return res.data;
  },

  alterarStatus: async (id, status) => {
    const res = await api.patch(`/empresas/${id}/status`, { status });
    return res.data;
  },

 // ⬇️ ADICIONA ESTE:
  percentuaisVigentes: async (id) => {
    const res = await api.get(`/empresas/${id}/percentuais-vigentes`);
    return res.data;
  },
};


export default empresaService;
